import { reactive } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  /** true = ação destrutiva (botão vermelho); false = botão na cor primária da empresa */
  danger?: boolean
}

interface ConfirmState {
  visible: boolean
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  danger: boolean
}

export const confirmState = reactive<ConfirmState>({
  visible: false,
  title: 'Confirmação',
  message: '',
  confirmLabel: 'Confirmar',
  cancelLabel: 'Cancelar',
  danger: false,
})

let resolvePromise: ((value: boolean) => void) | null = null

/**
 * Exibe a modal de confirmação global e aguarda a resposta do usuário.
 *
 * Uso: `if (!await confirmDialog({ message: 'Excluir item?', danger: true })) return`
 */
export function confirmDialog(options: ConfirmOptions | string): Promise<boolean> {
  const opts: ConfirmOptions = typeof options === 'string' ? { message: options } : options

  confirmState.title = opts.title || 'Confirmação'
  confirmState.message = opts.message
  confirmState.confirmLabel = opts.confirmLabel || 'Confirmar'
  confirmState.cancelLabel = opts.cancelLabel || 'Cancelar'
  confirmState.danger = opts.danger ?? false
  confirmState.visible = true

  return new Promise<boolean>((resolve) => {
    resolvePromise = resolve
  })
}

export function resolveConfirm(value: boolean) {
  confirmState.visible = false
  resolvePromise?.(value)
  resolvePromise = null
}
